import script from "./center-default.vue?vue&type=script&setup=true&lang=js"
export * from "./center-default.vue?vue&type=script&setup=true&lang=js"

import "./center-default.vue?vue&type=style&index=0&id=18e77f79&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e77f79"]])

export default __exports__